import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'history-icon',
  styleUrl: 'history-icon.css',
})
export class HistoryIcon {
  @Prop() icon: string = '';
  @Prop() label: string = '';
  @Prop() containerClass: string = '';
  @Prop() labelClass: string = '';

  render() {
    return (
      <div class={`flex flex-col items-center justify-center ${this.containerClass}`}>
        <svg-icon icon={this.icon} width="32px" height="32px" />
        <h5 class={`mt-1 font-bold text-center ${this.labelClass}`}>{this.label}</h5>
      </div>
    );
  }
}
